import { useIsOwner, useSessionPermission } from '@btime/react-session'
import React from 'react'

import { useNavigation } from '../../../utils/contexts/NavigationContext'
import { useOpenChecklistTemplatesModal } from '../../../utils/routes/modals/modalsActions'
import FixedRoundButton from '../../../components/actions/FixedRoundButton'

const AddNewButton = () => {
  let hasAddPermission = useSessionPermission('createChecklist')
  const navigate = useNavigation()

  const openTemplateModal = useOpenChecklistTemplatesModal()

  // TODO: Remove after templates is updated
  const isOwner = useIsOwner()

  if (!hasAddPermission) return false

  return (
    <FixedRoundButton
      onClick={() => {
        // TODO: Remove after templates is updated
        isOwner ? openTemplateModal() : navigate('/checklists/new')
      }}
    />
  )
}

export default AddNewButton
